module.exports = __webpack_public_path__ + "assets/d2aa5910f8a06c55bc48691f72cc6c05.svg";